import React from 'react';
import { Card, CardHeader, CardBody, Table, Row, Col, Input, Button } from 'reactstrap';

// eslint-disable-next-line
function renderIf(condition, trueComponent, falseComponent) {
	if (condition === true) {
		return trueComponent;
	} else {
		return falseComponent;
	}
}

class Userconfig extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			countryData: [],
			modalDemo: true,
			CPALink: '',
			Token: '',
			Patra: '',
			contraseña: '',
		};
		this.toggleModalDemo = this.toggleModalDemo.bind(this);
	}

	getSessionData(params) {
		return window.sessionStorage.getItem(params);
	}

	toggleModalDemo() {
		this.setState({
			modalDemo: !this.state.modalDemo,
		});
	}

	submit() {
		let that = this;
		if (this.state.CPALink !== '') {
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('load', () => {
				var res = JSON.parse(xhr.responseText);
				if (res.ok) {
					alert('Cambiado, reinicia session para verlo aqui :)');
				} else {
					console.log('error');
				}
			});

			xhr.open(
				'get',
				`${process.env.REACT_APP_BACKEND_URL}/user/changecpa?link=${encodeURIComponent(that.state.CPALink)}&token=${that.getSessionData(
					'UToken'
				)}`
			);
			xhr.setRequestHeader('Authorization', 'BEARER ' + that.getSessionData('VToken'));

			xhr.send();
		} else {
			alert('Pane el enlace, y esa vaina vacia?');
		}
	}
	handleCPALink(event) {
		this.setState({ CPALink: event.target.value });
	}
	submitcontraseña() {
		let that = this;
		if (this.state.contraseña !== '') {
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('load', () => {
				var res = JSON.parse(xhr.responseText);
				if (res.ok) {
					alert('Hecho');
					document.cookie.split(';').forEach(function (c) {
						document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
					});
					setTimeout(() => {
						window.location.reload();
					}, 1500);
				} else {
					console.log(that.getSessionData('UToken'));
				}
			});

			xhr.open(
				'get',
				`${process.env.REACT_APP_BACKEND_URL}/user/changepass?password=${encodeURIComponent(
					that.state.contraseña
				)}&utoken=${that.getSessionData('UToken')}`
			);
			xhr.setRequestHeader('Authorization', 'BEARER ' + that.getSessionData('VToken'));
			xhr.send();
		} else {
			alert(this.state.contraseña);
		}
	}
	handlecontraseña(event) {
		this.setState({ contraseña: event.target.value });
	}
	submitPatra() {
		let that = this;
		if (this.state.Patra !== '') {
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('load', () => {
				var res = JSON.parse(xhr.responseText);
				if (res.ok) {
					alert('Cambiado, reinicia session para verlo aqui :)');
				} else {
					console.log(that.getSessionData('UToken'));
				}
			});

			xhr.open(
				'get',
				`${process.env.REACT_APP_BACKEND_URL}/user/changeback?link=${encodeURIComponent(that.state.Patra)}&utoken=${that.getSessionData(
					'UToken'
				)}`
			);
			xhr.setRequestHeader('Authorization', 'BEARER ' + that.getSessionData('VToken'));
			xhr.send();
		} else {
			alert('y el patra bi? como vamo a da fli fla?');
		}
	}
	handlePatra(event) {
		this.setState({ Patra: event.target.value });
	}
	componentDidMount() {}

	render() {
		return (
			<>
				<div className='content'>
					<Row>
						{renderIf(
							this.getSessionData('typeofuser') === 'admin',

							<Col lg='6' md='12'>
								<Card>
									<CardHeader>
										<h6 className='title d-inline'>User Configurations</h6>
									</CardHeader>
									<CardBody>
										<div className='table-full-width table-responsive'>
											<Table>
												<tbody>
													<tr>
														<Input
															type='text'
															name='cpaLinkInput'
															id='cpaLinkInput'
															placeholder={this.getSessionData('linkcpa')}
															onChange={this.handleCPALink.bind(this)}
															value={this.state.CPALink}
														/>
														<Button
															color='success'
															className='animation-on-hover '
															onClick={() => {
																this.submit();
															}}
															style={{ marginTop: 1 + 'rem' }}
														>
															Cambiar link de la CPA
														</Button>
													</tr>
													<div style={{ paddingTop: 1 + 'rem' }}></div>

													<tr>
														<Input
															type='text'
															name="Pa 'tra"
															id="Pa 'tra"
															placeholder={this.getSessionData('linkback')}
															onChange={this.handlePatra.bind(this)}
															value={this.state.Patra}
														/>
														<Button
															color='success'
															className='animation-on-hover '
															onClick={() => {
																this.submitPatra();
															}}
															style={{ marginTop: 1 + 'rem' }}
														>
															Cambiar pa tra
														</Button>
													</tr>
												</tbody>
											</Table>
										</div>
									</CardBody>
								</Card>
							</Col>
						)}

						<Col lg='6' md='12'>
							<Card>
								<CardHeader>
									<h6 className='title d-inline'>Cambiar Contraseña</h6>
								</CardHeader>
								<CardBody>
									<div className='table-full-width table-responsive'>
										<Table>
											<tbody>
												<tr>
													<Input
														type='text'
														name='botsInput'
														id='botsInput'
														placeholder='Contraseña'
														onChange={this.handlecontraseña.bind(this)}
														value={this.state.contraseña}
													/>
													<Button
														color='success'
														className='animation-on-hover '
														onClick={() => {
															this.submitcontraseña();
														}}
														style={{ marginTop: 1 + 'rem' }}
													>
														Cambiar Contraseña
													</Button>
												</tr>
											</tbody>
										</Table>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default Userconfig;
